import { render, staticRenderFns } from "./yanjaing.vue?vue&type=template&id=ebe1bec4&"
import script from "./yanjaing.vue?vue&type=script&lang=js&"
export * from "./yanjaing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports